import entitiesView from 'images/platform_screenshot-crop_entities-view.webp';
import * as React from 'react';
export default {
  entitiesView,
  React
};